import { useCallback } from "react"

const useOnEnterKeyDown = (callback: (() => void) | undefined) => {
  const onEnter = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      // MacのChromeはIME確定時のkeyもEnterとなるため、isComposingでIME変換中かを見て判定します。
      // QUESTION Safariだとkeydownがcompositionendの後に発火するようなので、このコードでもIME確定時にコールバックが呼ばれる？（未検証）
      if (e.key === "Enter" && !e.nativeEvent.isComposing) {
        callback?.()
      }
    },
    [callback]
  )

  return onEnter
}

export default useOnEnterKeyDown
